import z from "zod";

enum RegistrationStep {
  realuser = "realuser",
  age = "age",
  sms = "sms",
  account = "account",
  finish = "finish",
}

const registrationInstanceSchema = z.object({
  version: z.string().default(""),
  description: z.string().default(""),
  your_ip: z.string(),
  registrations: z.boolean().default(true), // are registrations open?
  challenges: z.array(z.nativeEnum(RegistrationStep)),
  age_minimum: z.number().default(18),
  sms_countries: z.array(z.string()),
  your_country: z.string(), // country code
});

type RegistrationInstance = z.infer<typeof registrationInstanceSchema>;

export {
  registrationInstanceSchema,
  RegistrationStep,
  type RegistrationInstance,
};
